import { render, staticRenderFns } from "./benevolenceValue.vue?vue&type=template&id=0719e716&scoped=true"
import script from "./benevolenceValue.vue?vue&type=script&lang=js"
export * from "./benevolenceValue.vue?vue&type=script&lang=js"
import style0 from "./benevolenceValue.vue?vue&type=style&index=0&id=0719e716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0719e716",
  null
  
)

export default component.exports